import { getCheckedInAt } from './person-selectors';
export const sorterByCheckedInTime = (personA, personB) => getCheckedInAt(personA) - getCheckedInAt(personB);
